import { apiRequest } from 'utils/api';

const TOGGLE_SIDEBAR = 'sidebar/TOGGLE_SIDEBAR';
const LOAD_PRODUCTS = 'sidebar/LOAD_PRODUCTS';
const LOAD_SHARED_PRODUCTS = 'sidebar/LOAD_SHARED_PRODUCTS';
export const ADD_PRODUCT = 'sidebar/ADD_PRODUCT';

const initialState = {
  isOpen: false,
  products: []
};

export const loadSharedProducts = () => async dispatch => {
  const sharedUrl = process.env.REACT_APP_SHARED_API_URL;
  const businessUrl = process.env.REACT_APP_BUSINESS_WEB_URL;
  const url = sharedUrl + `/navigation/urlsforuser?businessWebBaseUrl=${businessUrl}`;
  const data = await apiRequest(url);
  if (!data.error) {
    dispatch({ type: LOAD_SHARED_PRODUCTS, data });
  }
};

export const toggleSidebar = () => {
  return { type: TOGGLE_SIDEBAR };
};

export const loadProducts = products => {
  return { type: LOAD_PRODUCTS, products };
};

export const addProduct = product => ({ type: ADD_PRODUCT, product });

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return { ...state, isOpen: !state.isOpen };

    case LOAD_PRODUCTS:
      return { ...state, products: action.products.sort(_sortProducts) };

    case ADD_PRODUCT: {
      const prods = JSON.parse(JSON.stringify(state.products));
      prods.push(action.product);
      return { ...state, products: prods.sort(_sortProducts) };
    }

    case LOAD_SHARED_PRODUCTS:
      const prods = action.data.map(d => {
        const ico = d.icon ? d.icon.replace('icon-', '').replace('icon ', '') : '';
        return {
          id: d.navigationID,
          url: d.url.includes('safnid') ? '/' : d.url,
          label: d.displayText,
          icon: ico
        };
      });
      return { ...state, products: prods };

    default:
      return state;
  }
};

const _sortProducts = (a, b) => {
  if (a.id < b.id) {
    return -1;
  }
  if (a.id > b.id) {
    return 1;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/common/jsx/layout/Sidebar/ducks.js